import { get } from '@/api/base'

export const getRouteStops = async containerUuid => {
  const { data } = await get({
    path: `containers/${containerUuid}/route_stops`,
  })

  return data
}
